import Vue from 'vue'

/**
 * Docker operations (deploys, updates, deletes…) started from the Applications
 * pages, kept while the customer moves between them so their progress banners
 * follow along. An operation id only means something on its own server, so each
 * entry carries the service id it belongs to.
 *
 *   dockerOperations.list → [{ serviceId, op: { id, label } }]
 */
export const dockerOperations = Vue.observable({ list: [] })

export function addDockerOperation (serviceId, op) {
  if (!op || !op.id || dockerOperations.list.some(o => o.op.id === op.id && o.serviceId === String(serviceId))) return
  dockerOperations.list.unshift({ serviceId: String(serviceId), op })
}

export function removeDockerOperation (serviceId, opId) {
  dockerOperations.list = dockerOperations.list.filter(o => !(o.op.id === opId && o.serviceId === String(serviceId)))
}
